'use client'

import { CaseStudy } from 'enums/CaseStudy.enum'
import { useDeviceType } from 'hooks/useDeviceType'
import styles from './SolutionAndServices.module.scss'

export type SolutionAndServicesProps = {
  caseStudy: CaseStudy
  problemSubtitle: string
  problemText: string
  solutionSubtitle: string
  solutionText: string
  serviceTitle?: string
  services: string[]
  hasVideo?: boolean
  hasGif?: boolean
}

const SolutionAndServices = ({
  caseStudy,
  problemSubtitle,
  problemText,
  serviceTitle = 'Services Provided',
  services,
  solutionSubtitle,
  solutionText,
  hasVideo = false,
  hasGif = false,
}: SolutionAndServicesProps) => {
  const { isMobile } = useDeviceType()

  function caseStudyFolder() {
    switch (caseStudy) {
      case 'acceligent':
        return 'construction'
      case 'audubon':
        return 'birds'
      case 'squadlocker':
        return 'apparel'
      case 'learn-rag':
        return 'learn-rag'
    }
  }

  return (
    <section className={styles.solution}>
      <div className={styles.content}>
        <div className={styles['text-block']}>
          <span className={styles.title + ' ' + styles[caseStudy]}>The Problem</span>
          <div className={styles.paragraph}>
            <h2 className={styles.subtitle}>{problemSubtitle}</h2>
            <p className={styles.text}>{problemText}</p>
          </div>
        </div>
        {hasVideo ? (
          <video autoPlay muted loop playsInline className={styles['solution-video']}>
            <source src={'/assets/work/' + caseStudyFolder() + '/solution-425w.webm'} media='(max-width: 430px)'></source>
            <source src={'/assets/work/' + caseStudyFolder() + '/solution-1024w.webm'} media='(max-width: 1024px)'></source>
            <source src={'/assets/work/' + caseStudyFolder() + '/solution-1920w.webm'}></source>
          </video>
        ) : hasGif ? (
          <div className={styles[caseStudy + '-gif-container']}>
            <video className={styles[caseStudy + '-gif']} autoPlay loop muted playsInline>
              <source src='/assets/work/pista/map-location.webm' type='video/webm' />
            </video>
          </div>
        ) : (
          <div className={styles[caseStudy + '-image']}></div>
        )}

        <div className={styles['text-block']}>
          <span className={styles.title + ' ' + styles[caseStudy]}>The Solution</span>
          <div className={styles.paragraph}>
            <h2 className={styles.subtitle}>{solutionSubtitle}</h2>
            <p className={styles.text}>{solutionText}</p>
          </div>
        </div>
      </div>
      <div className={styles.services}>
        <span className={styles.title}>{serviceTitle}</span>
        <ul className={styles.pills}>
          {services.map((service) => (
            <li key={service} className={styles.pill + ' ' + styles[caseStudy]}>
              {service}
            </li>
          ))}
          {isMobile && (
            <>
              {services.map((service) => (
                <li key={service} className={styles.pill + ' ' + styles[caseStudy]}>
                  {service}
                </li>
              ))}
            </>
          )}
        </ul>
      </div>
    </section>
  )
}

export default SolutionAndServices
